/**
 * ClassificacaoPage — Brief 4 (Gestor) · Tela 6 Configuração de Classificação.
 *
 * Rota: /admin/ia/classificacao. READ-ONLY: a régua dos 4 níveis é canônica
 * (`@lume/shared`), sem estado por-tenant → sem fetch/endpoint. Padrão D-B: gate
 * próprio na página (`tenant-config-read`), não confiar só na rota protegida.
 *
 * ATENÇÃO: CONFIG declarativa do Gestor — NÃO confundir com o runtime do
 * classification-agent (que produz o sensitivityLevel por IA) nem com a fatia
 * irmã "Gatilhos" (ADR-030 Eixo I). Não há CRUD de gatilhos keyword→nível
 * (honest-defer — sem mecanismo/consumidor no runtime).
 */

import { CapabilityLockedBanner } from '@lume/ui-components';

import { ClassificacaoView } from '../features/classificacao/ClassificacaoView';
import { useCapability } from '../hooks/use-capability';

import '../features/classificacao/classificacao.css';

export function ClassificacaoPage(): JSX.Element {
  const canRead = useCapability('tenant-config-read');

  // D-B — gate próprio, não confiar só na rota protegida.
  if (!canRead) {
    return (
      <div className="classificacao-screen classificacao-screen--gate">
        <CapabilityLockedBanner
          capability="tenant-config-read"
          tierMin="solo"
          fallbackMessage="A configuração de classificação é restrita a perfis com acesso às configurações do tenant."
        />
      </div>
    );
  }

  return <ClassificacaoView />;
}
